import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalDeletarSaldoInicioContaBanco } from "../redux/slices/contaBanco/contaBancoSlice";

export const cadastrarSaldoInicioContaBanco = createAsyncThunk("/SaldoInicioContaBanco/CadastrarSaldoInicioContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/SaldoInicioContaBanco/CadastrarSaldoInicioContaBanco", payload.value);
    toastSucess("Saldo cadastrado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarSaldoInicioContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarSaldoInicioContaBanco = createAsyncThunk("/SaldoInicioContaBanco/BuscarSaldoInicioContaBanco", async (pesquisar: number | null) => {
  try {
    const data = await api.get("/SaldoInicioContaBanco/BuscarSaldoInicioContaBanco", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarSaldoInicioContaBanco = createAsyncThunk("/SaldoInicioContaBanco/AtualizarSaldoInicioContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/SaldoInicioContaBanco/AtualizarSaldoInicioContaBanco", payload.value);
    toastSucess("Saldo inicial da conta bancária atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarSaldoInicioContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarSaldoInicioContaBanco = createAsyncThunk("/SaldoInicioContaBanco/DeletarSaldoInicioContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/SaldoInicioContaBanco/DeletarSaldoInicioContaBanco/?id=" + payload.value);
    toastSucess("Saldo removido com sucesso");
    dispatch(setModalDeletarSaldoInicioContaBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarSaldoInicioContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
